// src/pages/ResetPassword.jsx
import { useState } from "react";
import Button from "../components/Button";
import { useTranslation } from 'react-i18next';
import { forgotPassword } from "../api/api";
import Loading from "../components/Loading";

const ResetPassword = () => {
  const { t, i18n } = useTranslation();
  const [credentials, setCredentials] = useState({
    username: "",
  });
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setCredentials((prevCredentials) => ({
      ...prevCredentials,
      [id]: value,
    }));

    // Clear error message when user starts typing
    if (errorMsg) {
      setErrorMsg("");
    }
  };

  const handleResetAuth = async (e) => {
    e.preventDefault();
    const { username } = credentials;
    
    if (!username) {
      setErrorMsg(t('resetPassword.enterUsername'));
      return;
    }

    try {
      setLoading(true);
      setErrorMsg("");
      
      // Pass the current language as preferredLanguage
      const response = await forgotPassword(username, {
        preferredLanguage: i18n.language || 'en'
      });
      
      if (response.isSuccess) {
        setErrorMsg(t('resetPassword.successMessage'));
        setTimeout(() => {
          window.location.href = "/";
        }, 3000);
      } else {
        setErrorMsg(response.message || t('resetPassword.errorMessage'));
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      setErrorMsg(t('resetPassword.errorMessage'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="h-full w-full flex justify-center items-center p-5">
      <form className="border-2 p-10 rounded-xl flex flex-col gap-5 max-w-2/4 bg-zinc-100 justify-center items-start">
        <div className="w-full flex flex-col justify-center items-center mb-5">
          <h2 className="text-xl text-center font-semibold">
            {t('resetPassword.button')}
          </h2>
          <p className="text-sm text-gray-500 mt-2">
            {t('resetPassword.enterUsername')}
          </p>
        </div>

        <div className="w-full flex flex-col gap-2 justify-center items-start">
          <label htmlFor="username" className="labels block text-sm font-semibold">
            {t("signin.Username")} *
          </label>
          <input 
            onChange={handleChange} 
            value={credentials.username}
            autoComplete="off" 
            id="username" 
            type='text' 
            placeholder={t('signin.Username')}
            className={`min-w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
              !credentials.username && errorMsg === t('resetPassword.enterUsername') 
                ? 'border-red-500' 
                : 'border-gray-300'
            }`}
            disabled={loading}
          />
        </div>

        <div className="w-full flex flex-col gap-2">
          <div className="w-full flex justify-center items-center">
            {!loading ? 
              <Button 
                onClick={handleResetAuth} 
                label={t('resetPassword.button')} 
                variant="block"
                disabled={loading}
              />
              :
              <Loading/>
            }
          </div>

          <div className="w-full flex justify-center items-center">
            <a href="/" className="text-sm text-cyan-600">
              {t('signin.signinBtn')}
            </a>
          </div>
        </div>

        {errorMsg && (
          <span className={`w-full text-center p-2 ${
            errorMsg === t('resetPassword.successMessage') 
              ? 'text-green-600' 
              : 'text-red-500'
          }`}>
            {errorMsg}
          </span>
        )}
      </form>
    </section>
  );
};

export default ResetPassword;